import type { FaireProductEntity } from "../../entity_types/product";

export const p_f9yyhm4h9v: FaireProductEntity = {
  token: "p_f9yyhm4h9v",
  type: "product",
  name: "The Viral Dumpling Squishy- Glitter Edition :)",
  brandToken: "b_dyufggjqdw",
  brandName: "Think Sweet",
  imageUrl:
    "https://cdn.faire.com/fastly/63428a88a2341bfb11a4214bd8888ddf34cbed0943f37383d47acb4705337d00.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e5c6465244735c8d875f7cd62897a6cee28ae44aa860840375ae4808ef481365.jpeg",
    "https://cdn.faire.com/fastly/b6a1df46828cfdab08be84d0deb43539925232b502f6eff1742881a91133a8b0.jpeg",
    "https://cdn.faire.com/fastly/0cdc33ef835e4c992fe63f0ad11e833e834723a5f4fa2f8dad227500dd1fd430.jpeg",
    "https://cdn.faire.com/fastly/e2571ca7535e4c79719b79621559e1256dd37127e68dfa3913980798fcc57fcb.jpeg",
    "https://cdn.faire.com/fastly/e5a06ab2e233e4b7ef3eefd2dc708bffd6910f15a9f819651837be95cb46702b.jpeg",
    "https://cdn.faire.com/fastly/385c831fcf014b7cbe8088a7c3109413523246295dc4a10f301f39a45becaf75.jpeg",
    "https://cdn.faire.com/fastly/3c691f380cd04d8eed25066cb562eda97e3cea19008abc741169e1fc31f022bf.jpeg",
    "https://cdn.faire.com/fastly/0bbb78d2bf93739bfe5e472d442fd27b9016fe5c93b225d938bb5015814dd56c.jpeg",
    "https://cdn.faire.com/fastly/e2811a35022ada5ea6532772af6ace666504b67f7d31d6b14dac66aadbb3fc3d.jpeg",
    "https://cdn.faire.com/fastly/cbb235d3397d801b18c0887c4776ca542b5b44e2728973a00e8acaf3d2f878b7.png",
    "https://cdn.faire.com/fastly/d1f0c806b094f5bcab3dbef67a011b58c0c9589b03e2733507d65a358896face.jpeg",
  ],
  priceDollars: 6.5,
  description:
    "Embrace the joy of play with Think Sweet's Glitter Edition of the popular Squishy Dumpling. A delightful addition to any child's toy collection, this squishy toy provides a tactile experience that stimulates the senses. It's not just a toy, it's a fun-filled experience that sparks joy and fosters moments of togetherness. The Viral Squishy Dumpling is no exception. It's more than just a treat—it's an experience.",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:51:45.597Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
